import React from 'react';
import { HiOutlineUserPlus, HiOutlineCursorArrowRays, HiOutlineXMark, HiOutlineTrash } from 'react-icons/hi2';
import { Search } from 'react-bootstrap-icons';
import CheckboxMultiSelect from '../../../../../../../../components/common/CheckboxMultiSelect/CheckboxMultiSelect';
import './FilterBar.scss';

interface PuestoOption {
  puesto_id: number;
  puesto_name: string;
}

interface RoleOption {
  rol_id: number;
  rol_name: string;
}

interface FilterOption {
  value: string | number;
  label: string;
}

interface FilterBarProps {
  puestosOptions: PuestoOption[];
  rolesOptions: RoleOption[];
  selectedPuesto: FilterOption[];
  selectedRoles: FilterOption[];
  selectedEstado: FilterOption[];
  onPuestoChange: (selected: FilterOption[]) => void;
  onRolesChange: (selected: FilterOption[]) => void;
  onEstadoChange: (selected: FilterOption[]) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  showSelection: boolean;
  selectedUsersCount: number;
  onCreateUser: () => void;
  onToggleSelection: () => void;
  onDeleteSelection?: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  puestosOptions,
  rolesOptions,
  selectedPuesto,
  selectedRoles,
  selectedEstado,
  onPuestoChange,
  onRolesChange,
  onEstadoChange,
  searchValue,
  onSearchChange,
  showSelection,
  selectedUsersCount,
  onCreateUser,
  onToggleSelection,
  onDeleteSelection,
}) => {
  const puestosFilterOptions = puestosOptions.map(p => ({
    value: p.puesto_id,
    label: p.puesto_name
  }));

  const rolesFilterOptions = rolesOptions.map(r => ({
    value: r.rol_id,
    label: r.rol_name
  }));

  const estadoOptions = [
    { value: 1, label: 'Activo' },
    { value: 0, label: 'Inactivo' }
  ];

  return (
    <div className="mp-toolbar flex flex-wrap items-center gap-3">
      <div className="search-wrapper">
        <Search size={14} className="search-icon" />
        <input
          type="text"
          placeholder="Buscar usuarios..."
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="min-w-[120px]">
        <CheckboxMultiSelect options={puestosFilterOptions} value={selectedPuesto} onChange={onPuestoChange} placeholder="Puestos" />
      </div>
      <div className="min-w-[110px]">
        <CheckboxMultiSelect options={rolesFilterOptions} value={selectedRoles} onChange={onRolesChange} placeholder="Roles" />
      </div>
      <div className="min-w-[110px]">
        <CheckboxMultiSelect options={estadoOptions} value={selectedEstado} onChange={onEstadoChange} placeholder="Estado" />
      </div>

      {!showSelection && (
        <button className="mp-btn-primary" onClick={onCreateUser}>
          <HiOutlineUserPlus size={16} /> Crear usuario
        </button>
      )}

      <button className="mp-toolbar-btn" onClick={onToggleSelection}>
        {showSelection ? (
          <><HiOutlineXMark size={16} /> Cancelar</>
        ) : (
          <><HiOutlineCursorArrowRays size={16} /> Seleccionar</>
        )}
      </button>

      {showSelection && selectedUsersCount > 0 && onDeleteSelection && (
        <button className="mp-btn-danger" onClick={onDeleteSelection}>
          <HiOutlineTrash size={16} /> Eliminar ({selectedUsersCount})
        </button>
      )}
    </div>
  );
};

export default FilterBar;
